export const MARKETS = Object.freeze({
    DE: 'de',
    EN: 'en',
    ENCA: 'en-ca',
    ENGB: 'en-gb',
    ENNZ: 'en-nz',
    ES: 'es',
    FI: 'fi',
    IE: 'ie',
    JP: 'ja',
    NO: 'no',
    ROW: 'row',
    SV: 'sv',
    ROG: 'rog',
    ON: 'on'
    /* NEW_MARKET */
});

export const REGILY_COUNTRY = {
    [MARKETS.EN]: 'en', // this one is not set as country (it uses geo location inside regily)
    [MARKETS.FI]: 'fi',
    [MARKETS.NO]: 'no',
    [MARKETS.ENGB]: 'gb',
    [MARKETS.DE]: 'de',
    [MARKETS.ENCA]: 'ca',
    [MARKETS.SV]: 'se',
    [MARKETS.ENNZ]: 'nz',
    [MARKETS.IE]: 'ie',
    [MARKETS.ES]: 'es',
    [MARKETS.JP]: 'jp',
    [MARKETS.ON]: 'on'
    /* NEW_MARKET https://casumo.regily.com/playground.html - dont add hidden markets here! */
} as Record<string, string>;

export const REGILY_COUNTRY_REV = Object.entries(REGILY_COUNTRY).reduce(
    (acc, [market, country]) => ({ ...acc, [country]: market }),
    {}
) as Record<string, string>;

export const REGILY_LANGUAGE = {
    [MARKETS.EN]: 'en',
    [MARKETS.FI]: 'fi',
    [MARKETS.NO]: 'no',
    [MARKETS.ENGB]: 'en',
    [MARKETS.DE]: 'de',
    [MARKETS.ENCA]: 'en',
    [MARKETS.SV]: 'sv',
    [MARKETS.ENNZ]: 'en-NZ',
    [MARKETS.IE]: 'en',
    [MARKETS.ES]: 'es',
    [MARKETS.JP]: 'ja',
    [MARKETS.ROW]: 'en',
    [MARKETS.ROG]: 'en',
    [MARKETS.ON]: 'en'
    /* NEW_MARKET https://casumo.regily.com/playground.html */
} as Record<string, string>;

export const TRACKING_ID_COOKIE_KEY = 'kazumoTrackingId';
export const REGILY_FORM_ACTIVE_HASHES = ['#signup', '#playnow'];

export const REGILY_ENVS = Object.freeze({
    LIVE: 'live',
    STAGE: 'stage',
    TEST: 'test'
});

export const WO_TYPES = Object.freeze({
    SPORTS: 'odds',
    CASINO: 'casino',
    LIVE_CASINO: 'live-casino'
});

export const QUERY_PARAM_NAMES = Object.freeze({
    PREFERRED_OFFER: 'preferred_offer'
});

export const NEW_REGISTRATION_ENABLED_MARKETS = Object.freeze([
    MARKETS.EN,
    MARKETS.IE,
    MARKETS.ENNZ,
    MARKETS.ROW,
    MARKETS.ROG,
    MARKETS.ON,
    MARKETS.ENCA,
    MARKETS.ENGB,
    MARKETS.FI,
    MARKETS.NO,
    MARKETS.SV,
    MARKETS.ES
]) as string[];

export const REGILY_REMAINING_COUNTRIES_MAP = Object.freeze({
    ph: MARKETS.ROW,
    id: MARKETS.ROW,
    dz: MARKETS.ROG,
    eg: MARKETS.ROW,
    lb: MARKETS.ROG,
    qa: MARKETS.ROG,
    ae: MARKETS.ROG,
    kw: MARKETS.ROG,
    vn: MARKETS.ROW,
    sa: MARKETS.ROG,
    sb: MARKETS.ROW,
    th: MARKETS.ROW,
    bq: MARKETS.ROW,
    cr: MARKETS.ROW,
    na: MARKETS.ROW,
    bm: MARKETS.ROW,
    bo: MARKETS.ROW,
    kn: MARKETS.ROW,
    bb: MARKETS.ROW,
    pe: MARKETS.ROW,
    za: MARKETS.ROW,
    uy: MARKETS.ROW,
    rw: MARKETS.ROW,
    mv: MARKETS.ROW,
    pg: MARKETS.ROW,
    cu: MARKETS.ROW,
    ls: MARKETS.ROW,
    ai: MARKETS.ROW,
    gt: MARKETS.ROW,
    tl: MARKETS.ROW,
    cl: MARKETS.ROW,
    my: MARKETS.ROW,
    tz: MARKETS.ROW,
    tc: MARKETS.ROW,
    fj: MARKETS.ROW,
    kp: MARKETS.ROW,
    tt: MARKETS.ROW,
    lc: MARKETS.ROW,
    nr: MARKETS.ROW,
    cw: MARKETS.ROW,
    md: MARKETS.ROW,
    sc: MARKETS.ROW,
    sh: MARKETS.ROW,
    nu: MARKETS.ROW,
    io: MARKETS.ROW,
    cv: MARKETS.ROW,
    gd: MARKETS.ROW,
    hn: MARKETS.ROW,
    sz: MARKETS.ROW,
    do: MARKETS.ROW,
    gw: MARKETS.ROW,
    mz: MARKETS.ROW,
    ir: MARKETS.ROW,
    mh: MARKETS.ROW,
    ml: MARKETS.ROW,
    mk: MARKETS.ROW,
    sx: MARKETS.ROW,
    ru: MARKETS.ROW,
    mw: MARKETS.ROW,
    tk: MARKETS.ROW,
    gq: MARKETS.ROW,
    tv: MARKETS.ROW,
    mg: MARKETS.ROW,
    aw: MARKETS.ROW,
    kr: MARKETS.ROW,
    jm: MARKETS.ROW,
    la: MARKETS.ROW,
    ms: MARKETS.ROW,
    fk: MARKETS.ROW,
    br: MARKETS.ROW,
    bw: MARKETS.ROW,
    pn: MARKETS.ROW,
    vc: MARKETS.ROW,
    am: MARKETS.ROW,
    st: MARKETS.ROW,
    vg: MARKETS.ROW,
    ci: MARKETS.ROW,
    ge: MARKETS.ROW,
    mu: MARKETS.ROW,
    gs: MARKETS.ROW,
    fm: MARKETS.ROW,
    mx: MARKETS.ROW,
    zm: MARKETS.ROW,
    ky: MARKETS.ROW,
    to: MARKETS.ROW,
    ki: MARKETS.ROW,
    cc: MARKETS.ROW,
    ar: MARKETS.ROW,
    mn: MARKETS.ROW
    /* NEW_MARKET */
}) as Record<string, string>;

// In Canada we have province like Ontario that is working under a different jurisdiction.
// So we need to separate it from the rest of canadian provinces.
export const RESTRICTED_PROVINCE_MARKET_MAP = Object.freeze({
    ON: MARKETS.ON
}) as Record<string, string>;
